<template>
    <!-- 详情页-->
    <div id="email-send-file">
        <!--发送文件弹窗-->
        <div class="dialog-box act-sendfile-dialog" style="display: flex;" v-show="isShowEmailInput">
            <div class="dialog-mask"></div>
            <div class="dialog">
                <div class="dialog-head">
                    <div class="dialog-title"></div>
                    <div class="dialog-close act-dialog-close" @click="close">
                        <span class="iconfont icon-guanbi1"></span>
                    </div>
                </div>
                <div class="dialog-content">
                    请确认您的邮箱地址，<br/>我们会发送下载链接至您的邮箱。
                </div>
                <div class="dialog-input">
                    <input type="text" placeholder="请填写您的邮箱" v-model="email" @keyup="checkEmail" :class="{'input-error': isShowEmailError }"
                           autocomplete="set">
                </div>

                <div class="dialog-input-error" v-show="isShowEmailError">
                    <span class="error-icon">
                        <span class="iconfont icon-tishi"></span>
                    </span>
                    <span>请填写正确邮箱</span>
                </div>

                <div class="dialog-bt-g">
                    <div class="dialog-bt dialog-bt-confirm act-dialog-bt-confirm" @click="send">确认</div>
                </div>
            </div>
        </div>

        <!--发送成功toast-->
        <div class="toast-box sendfile-toast-box act-sendfile-toast-box" style="display: flex;"
             v-show="isShowSendSuccess">
            <div class="toast-content">
                <div class="toast-icon">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-xuanze"></use>
                    </svg>
                </div>
                <div class="toast-text">
                    <span class="text-line-one">提交成功，下载链接已发送到您的邮箱，请查收！</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EmailSendFile",
        data() {
            return {
                isShowEmailInput: false,
                isShowSendSuccess: false,
                isShowEmailError: false,
                email: '',
                userInfo: {},
                fileName:'',
                isSending: false,
                option:{
                    articleId:'',
                    fileId:'',
                    fileName:''
                }
            }
        },
        mounted() {
            this.confirm();
        },
        computed: {
        },
        methods: {

            checkEmail() {
                this.isShowEmailError =  !this.verificationEmail(this.email);
            },

            confirm(){
                this.isShowSendSuccess = false;
                this.isShowEmailInput = true;
                this.setEmail();
                return new Promise((resolve, reject) => {
                    this.promiseStatus = { resolve, reject };
                });
            },

            close(){
                this.isShowEmailInput = false;
                this.isShowSendSuccess = false;
                document.getElementById('email-send-file').remove()
            },

            async setEmail() {
                this.userInfo = await this.$tool.getUserInfo();
                this.email = this.userInfo?.email || '';
                console.log(this.userInfo.email)
            },

            //验证邮箱
            verificationEmail(email) {
                return email.match(/^\w+[\w\-\.]*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]{2,})+$/);
            },

            // 发送邮件
            async send() {
                this.checkEmail();
                if (this.isShowEmailError || this.isSending) {
                    return;
                }
                this.isSending = true;
                this.isShowEmailInput = false;
                //参数
                let option = {
                    articleId: this.option.articleId,
                    fileList: [this.option.fileId],
                    email: this.email,
                    forEmailTemp: false,
                    emailSubject: '戴尔企采官网-相关资料下载',
                    senderEmail: 'dellEmc@dell.com',
                    senderName: '戴尔企采官网',
                    sess: this.$tool.isLogin()?.sess || '',
                    openId: '',
                    referenceUrl: window.location.href,
                    instanceId: 0,
                    moduleType: 0,
                    extra: {
                        tenantId: '444',
                        instanceId: 0,
                        memberId: this.$tool.isLogin()?.memberId || '',
                        moduleId: 0,
                        openId: '',
                        weChatId: '93231',
                        objInstanceId: 0,
                        source: this.$tool.isM?'wap':'pc',
                    },
                    globalUserId: this.$tool.getGlobalUserId(),
                    browseInfo: this.$client.browseInfo,
                };

                this.gioAction('downloadConfirm',{
                    FilesTitle_Fifth: this.fileName,
                    FilesID_Fifth: this.fileId,
                    email_Fifth: this.email
                });

                let res = await this.$api.sendFileEmail(option);
                this.isSending = false;

                this.isShowEmailInput = false;
                if(res.body.result === 0){
                    // console.log('发送成功')
                    this.sendSuccess();
                }else{
                    // console.log('发送失败')
                    this.sendFail();

                }
            },

            sendSuccess(){
                this.isShowSendSuccess = true;
                setTimeout(()=>{
                    this.isShowSendSuccess = false;
                    this.close();
                },1000);
                this.promiseStatus.resolve()
            },

            sendFail(){
                this.close();
                this.promiseStatus.reject()
            }
        }
    }
</script>

<style scoped lang="less">
    // 弹窗动画
    /*.email-send-file-enter-active,*/
    /*.email-send-file-leave-active {*/
        /*transition: opacity .5s;*/
    /*}*/

    /*.email-send-file-enter,*/
    /*.email-send-file-leave-to {*/
        /*opacity: 0;*/
    /*}*/

    .dialog-box {
        width: 100%;
        height: 100%;
        z-index: 2147483602;
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        left: 0;
        font-size: 14px;

        .dialog-mask {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0;
            left: 0;
        }

        .dialog {
            width: 600px;
            border-radius: 5px;
            background: #fff;
            box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.1);
            text-align: center;
            position: relative;

            .dialog-close {
                color: #e0e0e0;
                font-size: 24px;
                position: absolute;
                right: 10px;
                top: 0;
                margin: 0;
                cursor: pointer;

                .iconfont {
                    font-size: 28px;
                }
            }

            .dialog-head {
                height: 38px;
                line-height: 38px;
                position: relative;
            }

            .dialog-title {
                color: #666;
                font-size: 16px;
                height: 38px;
                line-height: 38px;
            }

            .dialog-content {
                font-size: 24px;
                color: #999;
                line-height: 32px;
            }

            .dialog-input input {
                display: block;
                border: 1px solid #e9eef4;
                border-radius: 2px;
                background-color: #fafafa;
                width: 450px;
                height: 50px;
                margin: 16px auto 0 auto;
                font-size: 22px;
                color: #333333;
                padding-left: 20px;
                outline: none;

                &.error {
                    border: 1px solid #ff5959;
                }
            }

            .input-error {
                border: 1px solid #ff5959 !important;
            }

            .dialog-input-error {
                font-size: 22px;
                color: #ff0000;
                text-align: left;
                margin-top: 5px;
                margin-left: 58px;
            }
        }

        .dialog-bt-g {
            height: auto;
            padding-bottom: 38px;
            padding-top: 20px;
            position: relative;

            .dialog-bt {
                display: inline-block;
                border-radius: 5px;
                background-image: -webkit-linear-gradient(-10deg, rgb(0, 125, 184) 0%, rgb(0, 143, 209) 100%);
                background-image: -moz-linear-gradient(-10deg, rgb(0, 125, 184) 0%, rgb(0, 143, 209) 100%);
                background-image: -ms-linear-gradient(-10deg, rgb(0, 125, 184) 0%, rgb(0, 143, 209) 100%);
                background-image: linear-gradient(-10deg, rgb(0, 125, 184) 0%, rgb(0, 143, 209) 100%);
                box-shadow: 2px 2px 2px rgba(0, 125, 184, 0.13);
                -webkit-box-shadow: 2px 2px 2px rgba(0, 125, 184, 0.13);
                -moz-box-shadow: 2px 2px 2px rgba(0, 125, 184, 0.13);
                -ms-box-shadow: 2px 2px 2px rgba(0, 125, 184, 0.13);
                width: 250px;
                height: 55px;
                font-size: 24px;
                color: #f8fafd;
                line-height: 55px;
                text-align: center;
                margin: 0 10px;
                cursor: pointer;
                transition: all .3s;

                &:hover {
                    -webkit-box-shadow: 2px 2px 10px rgba(0, 125, 184, 0.5);
                    -moz-box-shadow: 2px 2px 10px rgba(0, 125, 184, 0.5);
                    -ms-box-shadow: 2px 2px 10px rgba(0, 125, 184, 0.5);
                }
            }
        }

        .dialog-error {
            width: 170px;
            height: 45px;
            position: absolute;
            left: 137px;
            top: 20px;
        }

        .icon-tishi {
            position: relative;
            top: 2px;
        }

        .icon-xuanze {
            position: relative;
            top: 1px;
        }
    }



    .sendfile-toast-box {
        z-index: 2147483603;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -49%);
        .toast-content {
            width: 80vw;
            border-radius: 5px;
            background-color: rgba(66, 174, 175, 0.702);
            border: 1px solid rgb(66, 174, 175);
            color: #fff;
            height: 60px;
            padding: 0 36px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .toast-icon {
            font-size: 40px;
            margin-right: 10px;
        }

        .toast-text {
            font-size: 22px;
        }
    }

</style>
